import React, { Component, Fragment } from 'react';
import { Form, Input, Select, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import GoogleMapReact from 'google-map-react';
import { genFormItemAtrribute } from 'libs/FormHelper';
import $ from 'jquery';
import _ from 'lodash';
import qs from 'query-string';
import AppHelper from 'libs/AppHelper';
import { API_HOST, GOOGLE_MAP_KEY } from '../../configs/env';
import whttp from '../../libs/whttp';
import WJSON from 'libs/wjson';
import './styles.module.scss';
import { __ } from '@wordpress/i18n';
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');
const Option = Select.Option;
// 前端頁面
export default class StoreMap extends Component {
  state = {
    query: {
      a: null,
      t: null,
      id: null,
      service_ids: [],
    },
  };

  componentDidMount() {
    const query = AppHelper.getHashParamaters();
    const cacheQuery = WJSON.decode(localStorage.getItem('c4-map-query')) || {
      a: null,
      t: null,
      id: null,
      service_ids: [],
    };

    if (!query.a && cacheQuery.a) {
      query.a = 1;
    }
    if (!query.service_ids && cacheQuery.service_ids) {
      query.service_ids = cacheQuery.service_ids;
    }
    console.log('componentDidMount', query, cacheQuery);
    this.setState({ query });
    this.loadConfig();
    this.loadData(query);
  }
  loadData = (query = {}) => {
    const cacheQuery = WJSON.decode(localStorage.getItem('c4-map-query')) || {
      a: null,
      t: null,
      id: null,
      service_ids: [],
    };
    query.service_ids = cacheQuery.service_ids;
    AppHelper.getStoreList(
      {
        store_type_id: query.t,
        store_area_id: query.a,
        service_ids: query.service_ids,
        id: query.id,
        page_size: 'all',
      },
      () => this.reloadMaps()
    );
  };
  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options }, () => {
        $('.selectpicker').selectpicker('refresh');
      });
    });
  };
  getGPS = () => {
    console.log(
      'geolocation',
      'geolocation' in navigator,
      navigator.geolocation
    );
    if ('geolocation' in navigator === false) {
      return;
    }

    navigator.geolocation.getCurrentPosition((position) => {
      console.log(
        'geolocation getCurrentPosition',
        position.coords.latitude,
        position.coords.longitude
      );
    });
  };
  reloadMaps = () => {
    const { map, maps } = this.state;
    console.log('reloadMaps', map, maps);

    if (!maps || !map) return;

    const stores = _.get(this, 'props.stores.listInfo.rows', []);
    if (!_.isArray(stores) || stores.length === 0) return;

    if (Array.isArray(this.state.markers)) {
      this.state.markers.forEach((marker) => marker.setMap(null));
    }

    // zoom預設為能呈現出地形等高線的大小
    // 所以改成呈現最新的裝置位置
    let bounds = new maps.LatLngBounds();

    const markers = stores.map((store, idx) => {
      var icon = '';
      if (store.store_type_id == 2)
        icon = `${
          window.VC_CONFIG.INDEX_URL
        }/wp-content/themes/cec/assets/img/icon/cec-m-loc.png`;
      else
        icon = `${
          window.VC_CONFIG.INDEX_URL
        }/wp-content/themes/cec/assets/img/icon/cec-loc.png`;

      const marker = new maps.Marker({
        map: map,
        position: { lat: store.latitude, lng: store.longitude },
        store: store,
        icon: icon,
      });

      let infowindow = new maps.InfoWindow({
        content: `<div jstcache="33" class="poi-info-window gm-style"> <div jstcache="2"> <div jstcache="3" class="title full-width" jsan="7.title,7.full-width">${
          store.name
        }</div><div class="address"> <div jstcache="4" jsinstance="*0" class="address-line full-width" jsan="7.address-line,7.full-width">${
          store.address
        }</div> </div> </div>`,
      });
      marker.addListener('click', function() {
        infowindow.open(map, marker);
      });
      // marker.addListener('mouseover', function () {
      //   infowindow.open(map, marker);
      // });

      // marker.addListener('mouseout', function () {
      //   infowindow.close();
      // });

      if (idx == 0) {
        bounds.extend(marker.getPosition());
      }
      return marker;
    });

    map.fitBounds(bounds);

    map.setZoom(16);

    this.setState({ markers });
  };
  refreshPicker = _.debounce(() => {
    const query = _.get(this, 'state.query', {});
    $('.selectpicker[name=id]').selectpicker('val', _.get(query, 'id'));
    $('.selectpicker').selectpicker('refresh');
  }, 1000);
  handleQueryUpdate = (key, value) => {
    console.log('handleQueryUpdate', key, value);
    const query = _.get(this, 'state.query', {});
    console.log('query', query);
    const cacheQuery = WJSON.decode(localStorage.getItem('c4-map-query')) || {
      a: null,
      t: null,
      id: null,
      service_ids: [],
    };
    query.service_ids = cacheQuery.service_ids;
    console.log('cacheQuery', cacheQuery);
    console.log('query111', query);
    _.set(query, key, value);

    if (key === 'a' || key === 't' || key === 'service_ids') {
      _.set(query, 'id', null);
      // delete query.id
      console.log('handleQueryUpdate', $('.selectpicker[name=id]'));
      $('.selectpicker[name=id]').selectpicker('val', null);
    }
    console.log('handleQueryUpdate555', query);
    localStorage.setItem('c4-map-query', WJSON.encode(query));

    console.log('handleQueryUpdate', key, value, query);

    this.loadData(query);

    this.setState({ query }, () => {
      this.refreshPicker();
    });
  };
  getSearchPath = (query) => {
    const Local = _.get(window, 'VC_CONFIG.Locale');
    if (Local == 'en_US')
      return (
        window.VC_CONFIG.INDEX_URL +
        `/stores-en/#` +
        qs.stringify(query, { skipNull: true })
      );
    return (
      window.VC_CONFIG.INDEX_URL +
      `/stores/#` +
      qs.stringify(query, { skipNull: true })
    );
  };

  render() {
    const listInfo = _.get(this, 'props.stores.listInfo', []);
    // const options = _.get(this, 'props.app.options', {})
    const options = _.get(this, 'state.options', {});
    const query = _.get(this, 'state.query', {});
    this.refreshPicker();

    return (
      <div className='banner-location'>
        <div id='map'>
          <GoogleMapReact
            bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
            defaultCenter={[25.1243218, 121.4971524]}
            defaultZoom={13}
            options={{
              mapTypeControl: false,
              styles: [{ elementType: 'all' }],
            }}
            yesIWantToUseGoogleMapApiInternals={true}
            onGoogleApiLoaded={({ map, maps }) =>
              this.setState({ map, maps }, () => this.reloadMaps())
            }
          />
        </div>

        <div className='map-filter-bar'>
          <div className='container'>
            <div className='row justify-content-center no-gutters mx-n2'>
              <div className='col-md-3 px-2'>
                <div className='form-group'>
                  <select
                    className='form-select selectpicker'
                    name='store_area_id'
                    value={query.a}
                    data-none-selected-text='請選擇城市區域'
                    onChange={(e) =>
                      this.handleQueryUpdate(
                        'a',
                        !isNaN(parseInt(e.target.value, 10))
                          ? parseInt(e.target.value, 10)
                          : null
                      )
                    }
                  >
                    <option value={null} disabled>
                      {__('請選擇城市區域', 'cec-plugin-stores')}
                    </option>
                    {_.map(_.get(options, 'store_areas', []), (item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className='col-md-3 px-2'>
                <div className='form-group'>
                  <select
                    className='form-select selectpicker'
                    name='store_type_id'
                    value={query.t}
                    data-none-selected-text={__(
                      '請選擇分店型態',
                      'cec-plugin-stores'
                    )}
                    onChange={(e) =>
                      this.handleQueryUpdate(
                        't',
                        !isNaN(parseInt(e.target.value, 10))
                          ? parseInt(e.target.value, 10)
                          : null
                      )
                    }
                  >
                    <option value={null}>
                      {__('請選擇分店型態', 'cec-plugin-stores')}{' '}
                    </option>
                    {_.map(_.get(options, 'store_types', []), (item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className='col-md-3 px-2'>
                <div className='form-group'>
                  <select
                    className='form-select selectpicker'
                    name='id'
                    data-none-selected-text='請選擇分店'
                    value={_.get(query, 'id', null)}
                    onChange={(e) =>
                      this.handleQueryUpdate(
                        'id',
                        !isNaN(parseInt(e.target.value, 10))
                          ? parseInt(e.target.value, 10)
                          : null
                      )
                    }
                  >
                    <option value={null}>
                      {__('請選擇分店', 'cec-plugin-stores')}{' '}
                    </option>
                    {_.map(_.get(listInfo, 'rows', []), (item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className='col-md-auto px-2'>
                <a
                  className='btn btn-primary btn-search'
                  href={this.getSearchPath(query)}
                  onClick={() => this.loadData(query)}
                >
                  <i className='icon-search mr-3 mr-md-0' />
                  <span className='h6 mb-0 d-md-none'>搜尋分店</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// 後台編輯器
export class StoreMapEditor extends Component {
  render() {
    return (
      <div style={{ height: '50vh', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: GOOGLE_MAP_KEY }}
          defaultCenter={[25.1243218, 121.4971524]}
          defaultZoom={13}
          options={{ mapTypeControl: false }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/stores/store-map.js